/**
 * @fileoverview GET handler for the "/integrations/get_technology_partners_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { integrationsGetTechnologyPartnersData } from "./constants";
import type { IntegrationsGetTechnologyPartnersDataResults } from "./types";

export const getIntegrationsGetTechnologyPartnersData = reactQueryFetcherAdapter(
  integrationsGetTechnologyPartnersData,
  (signal: AbortSignal): Promise<IntegrationsGetTechnologyPartnersDataResults> => {
    return fetch("/integrations/get_technology_partners_data", "GET", {}, { signal });
  }
);
